import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	PointElement,
	LineElement,
	Tooltip,
	Legend,
	BarController,
	LineController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { useTheme } from '@material-ui/core/styles';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	PointElement,
	LineElement,
	Tooltip,
	Legend,
	BarController,
	LineController
);

export default function ComboChart({ labels, bars, line }) {
	const theme = useTheme();
	const txt = theme.palette.text.primary;
	const grid = theme.palette.divider;
	const data = {
		labels,
		datasets: [
			...bars.map((b) => ({
				type: 'bar',
				label: b.label,
				data: b.data,
				backgroundColor: b.color,
				borderColor: b.color,
				yAxisID: 'yLeft',
				order: 2,
			})),
			{
				type: 'line',
				label: line.label,
				data: line.data,
				borderColor: line.color,
				backgroundColor: line.color,
				tension: 0.35,
				borderWidth: 2,
				pointRadius: 3,
				yAxisID: 'yRight',
				order: 1,
			},
		],
	};
	const options = {
		maintainAspectRatio: false,
		interaction: { mode: 'index', intersect: false },
		plugins: {
			legend: { position: 'bottom', labels: { boxWidth: 12, font: { size: 11 }, color: txt } },
			tooltip: {
				titleColor: txt,
				bodyColor: txt,
				callbacks: {
					label: (ctx) => {
						const v = ctx.parsed.y;
						if (v == null) return ` ${ctx.dataset.label}: —`;
						return ` ${ctx.dataset.label}: ${ctx.dataset.type === 'line' ? v + '%' : v}`;
					},
				},
			},
			datalabels: {
				color: txt,
				formatter: (value, ctx) => (ctx.dataset.type === 'line' ? (value == null ? '' : value + '%') : value),
			},
		},
		scales: {
			yLeft: { position: 'left', beginAtZero: true, ticks: { precision: 0, color: txt }, grid: { color: grid } },
			yRight: {
				position: 'right',
				beginAtZero: true,
				grid: { drawOnChartArea: false },
				ticks: { callback: (v) => v + '%', color: txt },
			},
			x: { grid: { display: false }, ticks: { color: txt } },
		},
	};
	return <Chart type="bar" data={data} options={options} />;
}
